import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { Dropdown, Space, Table } from "antd";
import TableAntd from "components/elements/Table/Table";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
const EmployeeInfoEducationTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  onEdit = () => { },
  onDelete = () => { },
  onChange = () => { },
}) => {
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  const language = i18n.language == "en" ? "En" : ""

  const columns = [
    {
      title: <div className="text-table">{t('employee.no')}</div>,
      dataIndex: "no",
      key: "no",
      width: "8%",
      render: (_, record, idx) => {
        return (
          <span
            style={{
              color: "#313131",
              backgroundColor: "#F5F6F7",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "auto",
            }}
          >
            {idx + 1}
          </span>)
      },
    },
    {
      title: <div className="text-table">{t('employee.institute')}</div>,
      dataIndex: "institute",
      key: "institute",
      render: (_, record) => {
        return <span style={{ color: "#42526D" }}>{record?.institute ? record?.institute : "-"}</span>
      }
    },
    {
      title: <div className="text-table">{t('employee.education-degree')}</div>,
      dataIndex: "educationDegreeName",
      key: "educationDegreeName",
      render: (_, record) => {
        return <span style={{ color: "#42526D" }}>{record?.educationDegree ? record?.educationDegree?.["name" + language] : "-"}</span>
      }
    },
    {
      title: <div className="text-table">{t('employee.graduated-from')}</div>,
      dataIndex: "graduatedFrom",
      key: "graduatedFrom",
      render: (_, record) => {
        if (record?.graduatedFrom) {
          return <span style={{ color: "#42526D" }}>{record?.graduatedFrom === 'local' ? t('employee.local') : t('employee.aboard-0')}</span>
        }
      },
    },
    {
      title: <div className="text-table">{t('employee.faculty')}</div>,
      dataIndex: "faculty",
      key: "faculty",
      render: (_, record) => {
        return <span style={{ color: "#42526D" }}>{record.faculty ? record.faculty : "-"}</span>;
      },
    },
    {
      title: <div className="text-table">{t('major-subject')}</div>,
      dataIndex: "majorSubject",
      key: "majorSubject",
      render: (_, record) => {
        return <span style={{ color: "#42526D" }}>{record.majorSubject ? record.majorSubject : "-"}</span>;
      },
    },
    {
      title: <div className="text-table">{t('gpax')}</div>,
      dataIndex: "gpax",
      key: "gpax",
      render: (_, record) => {
        if (record?.gpax) {
          return <span style={{ color: "#42526D" }}>
            {/* {record?.gpax?.length > 1 ? record?.gpax : record?.gpax + ".00"} */}
            {get2DecimalPointsWithCommas(record?.gpax)}
          </span>;
        }
      },
    },
    {
      title: <div className="text-table">{t('start-year')}</div>,
      dataIndex: "startDate",
      key: "startDate",
      render: (_, record) => {
        return <span style={{ color: "#42526D" }}>{record.startDate ? record.startDate : "-"}</span>;
      },
    },
    {
      title: <div className="text-table">{t('end-year')}</div>,
      dataIndex: "endDate",
      key: "endDate",
      render: (_, record) => {
        return <span style={{ color: "#42526D" }}>{record.endDate ? record.endDate : "-"}</span>;
      },
    },
    roles.includes("UPDATE_EMPLOYEE|EMPLOYEE_INFO|EDUCATION") || roles.includes("DELETE_EMPLOYEE|EMPLOYEE_INFO|EDUCATION") ? {
      title: "",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                roles.includes("UPDATE_EMPLOYEE|EMPLOYEE_INFO|EDUCATION") && {
                  key: "1",
                  onClick: () => onEdit(record),
                  label: `${t("action.edit")}`,
                  icon: (
                    <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
                roles.includes("DELETE_EMPLOYEE|EMPLOYEE_INFO|EDUCATION") && {
                  key: "2",
                  onClick: () => onDelete(record),
                  label: `${t("action.delete")}`,
                  icon: (
                    <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>

        </Space>
      ),
    } : {}
  ];

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={dataSource}
      rowKey={(record) => record.id}
      columns={columns}
      onChange={onChange}
    />
  );
};

export default EmployeeInfoEducationTable;
